module.exports = __webpack_public_path__ + "static/media/Baseball Player.10ea3ec6.jpg";